import { initAnalyticsSlider } from './analytics-slider.js';
import { initLeadForms } from './lead-form.js';
import { initLoadMore } from './load-more.js';
import { initNavToggle } from './nav-toggle.js';
import { initPopups } from './popup.js';

document.addEventListener('DOMContentLoaded', () => {
	initAnalyticsSlider();
	initLeadForms();
	initLoadMore();
	initNavToggle();
	initPopups();
});
